module.exports = __webpack_public_path__ + "img/prairiedog011.3b439fec.jpg";